<ng-dialog-header title="Train Route"></ng-dialog-header>
<mat-dialog-content>
  <mat-tab-group class="ns-mat-tab-group overflow-auto h-100 flex-grow-1" animationDuration="0ms">
    <mat-tab>
      <ng-template mat-tab-label>Route</ng-template>
      <div class="h-100">
        <div class="py-3">Current Shipment Location: {{ trainRoute?.currentShipmentLocation | date:'MM/dd/yyyy hh:mm a' }}</div>
        <div class="row">
          <div class="col">
            <div class="row">
              <div class="col"><strong>Permit:</strong></div>
              <div class="col">{{ trainRoute?.empty }} {{ trainRoute?.emptyDate | date:'MM/dd/yyyy hh:mm a' }}</div>
            </div>
            <div class="row">
              <div class="col"><strong>Origin:</strong></div>
              <div class="col">{{ trainRoute?.origin }}</div>
            </div>
            <div class="row">
              <div class="col"><strong>Product Class:</strong></div>
              <div class="col">{{ trainRoute?.productClass }}</div>
            </div>
            <div class="row">
              <div class="col"><strong>Train:</strong></div>
              <div class="col">{{ trainRoute?.train }}</div>
            </div>
            <div class="row">
              <div class="col"><strong>Current Location:</strong></div>
              <div class="col">{{ trainRoute?.currentLocation }}</div>
            </div>
            <div class="row">
              <div class="col"><strong>Last Move Date and Time:</strong></div>
              <div class="col">{{ trainRoute?.lastMoveDateTime | date:'MM/dd/yyyy hh:mm a' }}</div>
            </div>
            <div class="row">
              <div class="col"><strong>ETA:</strong></div>
              <div class="col">{{ trainRoute?.eta | date:'MM/dd/yyyy hh:mm a' }}</div>
            </div>
          </div>
          <div class="col-2 d-none d-lg-block"></div>
          <div class="col">
            <div class="row">
              <div class="col"><strong>Nbr of Cars Waybilled:</strong></div>
              <div class="col">{{ trainRoute?.noOfCarsWaybilled }}</div>
            </div>
            <div class="row">
              <div class="col"><strong>Nbr of Cars Released:</strong></div>
              <div class="col">{{ trainRoute?.noOfCarsReleased }}</div>
            </div>
            <div class="row">
              <div class="col"><strong>Scheduled Load Date:</strong></div>
              <div class="col">{{ trainRoute?.scheduledLoadDate | date:'MM/dd/yyyy hh:mm a' }}</div>
            </div>
            <div class="row">
              <div class="col"><strong>Requested Delivery Date:</strong></div>
              <div class="col">{{ trainRoute?.requestDeliveryDate | date:'MM/dd/yyyy hh:mm a' }}</div>
            </div>
            <div class="row">
              <div class="col"><strong>Trace Car:</strong></div>
              <div class="col">{{ trainRoute?.traceCar }}</div>
            </div>
            <div class="row">
              <div class="col"><strong>Waybill Serial:</strong></div>
              <div class="col">{{ trainRoute?.waybillSerialNumber }}</div>
            </div>
            <div class="row">
              <div class="col"><strong>Revenue Waybill:</strong></div>
              <div class="col">{{ trainRoute?.revenueWaybill }}</div>
            </div>
          </div>
        </div>
        <ns-grid class="h-100"
                 [gridTitle]="gridConfigurations.gridTitle"
                 [name]="gridConfigurations.gridName"
                 [columns]="gridConfigurations.columns"
                 [data]="trainRoute?.routeDetails || []"
                 [loading]="loading"
                 [gridOptions]="gridConfigurations.options"
                 [config]="gridConfigurations.headerOptions">
        </ns-grid>
      </div>
    </mat-tab>
    <mat-tab label="Map Route">
      <ng-template matTabContent>
        <ng-ctms-map [traces]="traces" [loading]="tracesLoading"></ng-ctms-map>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
<ng-dialog-footer>
  <div dialog-actions class="d-flex justify-content-end w-100">
    <button mat-stroked-button color="warn" aria-label="close" mat-dialog-close>Close</button>
  </div>
</ng-dialog-footer>
